import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { PayrollRulesPage } from "@/pages/dashboard/payroll-runs/rules";

export const Route = createFileRoute("/_main/dashboard/payroll-runs/rules")({
  component: () => (
    <RequirePermission action="payroll.read">
      <PayrollRulesPage />
    </RequirePermission>
  ),
});
